// All actions and state related to a User's owned Hearts

import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { createHeartOnServer, createItemOnServer, deleteItemOnServer } from "../api/api";


// Async thunk to add a heart
export const addHeartToReduxAndServer = createAsyncThunk(
    'hearts/addHeart',
    async (heartData, thunkAPI) => {
        try {
            // Send a POST request to create the heart on the server
            const newHeart = await createItemOnServer('hearts', heartData);
            return newHeart;
        } catch (error) {
            // Return the rejected promise with the error message
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

// Async thunk to update a heart
export const updateHeartOnReduxAndServer = createAsyncThunk(
    'hearts/updateHeart',
    async ({ id, updatedHeart }, thunkAPI) => {
        try {
            const updated = await createItemOnServer('hearts', updatedHeart);
            return { id, updatedHeart: updated };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

// Async thunk to remove a heart
export const removeHeartFromReduxAndServer = createAsyncThunk(
    'hearts/removeHeart',
    async (heartID, thunkAPI) => {
        try {
            // Send a DELETE request to remove the heart from the server
            await deleteItemOnServer('hearts', heartID);
            return heartID;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);


const initialState = {
    hearts: [],
    // hearts in user's groups that are not owned by the user
    groupHearts: [],
    tempHeart: {},
    isVerified: false,
};

export const heartSlice = createSlice({
    name: "heart",
    initialState,
    reducers: {
        addHeart: (state, action) => {
            state.hearts.push(action.payload);
            // TODO: add the heart to the database
        },
        addGroupHeart: (state, action) => {
            state.groupHearts.push(action.payload);
        },
        updateGroupHearts: (state, action) => {
            state.groupHearts = action.payload;
        },
        clearReduxHearts: (state, action) => {
            state.hearts = [];
            state.groupHearts = [];
        },
        updateTempHeart: (state, action) => {
            state.tempHeart = action.payload;
        },
        updateIsVerified: (state, action) => {
            state.isVerified = action.payload;
        },
        updateHeart: (state, action) => {
            const { id, updatedHeart } = action.payload;
            state.hearts = state.hearts.map((heart) => heart.id === id ? updatedHeart : heart);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(addHeartToReduxAndServer.fulfilled, (state, action) => {
            state.hearts.push(action.payload);
        })
            .addCase(addHeartToReduxAndServer.pending, (state, action) => {
            console.log("Adding heart to server...");
        })
            .addCase(addHeartToReduxAndServer.rejected, (state, action) => {
            console.error("Error adding heart to server: ", action.payload);
        })
            .addCase(updateHeartOnReduxAndServer.fulfilled, (state, action) => {
            const { id, updatedHeart } = action.payload;
            state.hearts = state.hearts.map((heart) => heart.id === id ? updatedHeart : heart);
        })
            .addCase(updateHeartOnReduxAndServer.pending, (state, action) => {
            console.log("Updating heart on server...");
        })
            .addCase(updateHeartOnReduxAndServer.rejected, (state, action) => {
            console.error("Error updating heart on server: ", action.payload);
        })
            .addCase(removeHeartFromReduxAndServer.fulfilled, (state, action) => {
            console.log("Successfully removed heart from server.");
            state.hearts = state.hearts.filter((heart) => heart.id !== action.payload);
        })
            .addCase(removeHeartFromReduxAndServer.pending, (state, action) => {
            console.log("Removing heart from server...");
        })
            .addCase(removeHeartFromReduxAndServer.rejected, (state, action) => {
            console.error("Error removing heart from server: ", action.payload);
        });
    },
});

// export the actions
export const { addHeart, updateGroupHearts, addGroupHeart, clearReduxHearts, updateTempHeart, updateIsVerified, updateHeart} = heartSlice.actions;

// export the reducer
export default heartSlice.reducer;